const legalEntityForm = {
  /**
   * Client form key
   * @type {String}
   */
  key: "legalEntityForm",

  /**
   * Client form fields object
   * @type {Object}
   */
  fields: {
    firmName: "",
    legalForm: "",
    taxpayerNumber: "",
    identificationNumber: "",
    phone: "",
    email: "",
    city: "",
    address: "",
    zipCode: "",
    note: "",
    bookingNotificationsEnabled: false,
    marketingNotificationsEnabled: false,
  },

  /**
   * Client form helpers object
   * @type {Object}
   */
  helpers: {},

  /**
   * Client form errors object
   * @type {Object}
   */
  errors: {},

  /**
   * Client form mode
   * @type {String}
   */
  mode: "create",

  /**
   * Client form path
   * @type {String}
   */
  path: "/api/b2b/legal-entities",
};

export default legalEntityForm;
